module.exports = __webpack_public_path__ + "fonts/icomoon.7bd8d4f7.ttf";